import type { ConnectorOverview } from "@/lib/api";
import { i18n } from "@/lib/i18n";

/** A line of the connector card: on or off, in plain words. */
export interface StatusLine {
  on: boolean;
  label: string;
  detail: string;
}

/** How the connector runs, in plain words (`mode` of `GET /mcp/overview`), in the dashboard's language. */
export function connectorStatus(mode: ConnectorOverview["mode"]): StatusLine {
  const t = i18n.t;
  switch (mode) {
    case "microsoft":
      return { on: true, label: t("common.on"), detail: t("connector.microsoftDetail") };
    case "local":
      return { on: true, label: t("connector.localLabel"), detail: t("connector.localDetail") };
    case "off":
      return { on: false, label: t("common.off"), detail: t("connector.offDetail") };
  }
}

/** Whether Claude can read Odoo through the connector, and why not. */
export function odooStatus(
  overview: Pick<ConnectorOverview, "mode" | "odoo_tools_on">,
): StatusLine {
  const t = i18n.t;
  if (overview.odoo_tools_on) {
    return { on: true, label: t("common.on"), detail: t("connector.odooOnDetail") };
  }
  if (overview.mode === "off") {
    return { on: false, label: t("common.off"), detail: t("connector.odooConnectorOffDetail") };
  }
  return { on: false, label: t("common.off"), detail: t("connector.odooNotConnectedDetail") };
}
